(function () {
    'use strict';

    angular
        .module('studyad')
        .controller('StudyAdEventsController', StudyAdEventsController);

    StudyAdEventsController.$inject = ['StudyAdService'];

    function StudyAdEventsController(StudyAdService) {
        var vm = this;
        vm.getEvents = getEvents;
        vm.getByFilter = getByFilter;
        vm.eventSelected = '';
        vm.flag = false;

        /*PAGINATION*/
        vm.pageChanged            = pageChanged;
        vm.setPage                = setPage;
        vm.totalItems             = [];
        vm.to                     = [];
        vm.currentPage            = null;
        vm.itemsPerPage           = [];
        vm.page                   = 1;

        function getEvents () {
            StudyAdService.getEvents().then(function(response){
                vm.events = response.data;
            });
        }

        function getByFilter() {
            vm.flag = false;
            let query = {};
            if(query['studyad_event_id'] != '') {
                query['studyad_event_id'] = vm.eventSelected;
            }
            query['page'] = vm.page;
            StudyAdService.getUsers(query).then(function(response){
                vm.users = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
                vm.flag = true;
            }).catch(function(err) {
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function activate () {
            vm.getEvents();
        }

        activate();
    }

})();